import React, { useEffect, useState } from 'react';
import axios from 'axios';
import progressGif from '../../images/progress.gif';

const Portability_Drawl_Fps = ({ month, year, block, district, excludeFpsId }) => {
  const [fpsData, setFpsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFpsData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL_SALE}/api/portabilityDrawl/fpsDrawl`,
          { params: { month, year, block, excludeFpsId } }
        );
        setFpsData(response.data);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    if (month && year && block) fetchFpsData();
  }, [month, year, block, excludeFpsId]);

  const monthName = new Date(year, month - 1).toLocaleString('default', { month: 'long' });

  if (loading)
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <img src={progressGif} alt="Loading..." width="200" />
      </div>
    );

  if (error)
    return (
      <div style={{ textAlign: 'center', color: 'red', marginTop: '20px' }}>
        Error fetching FPS data
      </div>
    );

  if (!fpsData || fpsData.length === 0)
    return (
      <div style={{ textAlign: 'center', color: 'red', marginTop: '20px' }}>
        No FPS Data Found
      </div>
    );

  const totals = fpsData.reduce(
    (acc, item) => {
      acc.totalCards += item.totalCards || 0;
      acc.drawlRc += item.drawlRc || 0;
      acc.wheat += item.wheat || 0;
      acc.sugar += item.sugar || 0;
      acc.frice += item.frice || 0;
      acc.sfrice += item.sfrice || 0;
      return acc;
    },
    { totalCards: 0, drawlRc: 0, wheat: 0, sugar: 0, frice: 0, sfrice: 0 }
  );

  return (
    <div style={{ marginTop: '20px' }}>
      <table
        align="center"
        width="80%"
        border={1}
        style={{ borderCollapse: 'collapse' }}
      >
        <thead>
          <tr
            className='tableheader'
          >
            <th colSpan={8}>
              FPS WISE UNIQUE RC and SALE DETAILS - {block} - {district} - {monthName} / {year}
            </th>
          </tr>
          <tr className="tableheader">
            <th rowSpan={2} style={{ textAlign: 'left', paddingLeft: '8px' }}>Sl. No</th>
            <th rowSpan={2}>FPS</th>
            <th rowSpan={2}>Total Cards</th>
            <th rowSpan={2}>Drawl Cards</th>
            <th colSpan={4}>Total Drawl Qty (Kg)</th>
          </tr>
          <tr className="tableheader">
            <th>Wheat</th>
            <th>Sugar</th>
            <th>Fortified Sannabiyyam</th>
            <th>S-Fortified Sannabiyyam</th>
          </tr>
        </thead>
        <tbody>
          {fpsData.map((item, index) => (
            <tr key={index}>
              <td style={{ textAlign: 'left', paddingLeft: '8px' }}>{index + 1}</td>
              <td style={{ textAlign: 'left' }}>{item.fpsId}</td>
              <td style={{ textAlign: 'right' }}>{item.totalCards}</td>
              <td style={{ textAlign: 'right' }}>{item.drawlRc}</td>
              <td style={{ textAlign: 'right' }}>{item.wheat}</td>
              <td style={{ textAlign: 'right' }}>{item.sugar}</td>
              <td style={{ textAlign: 'right' }}>{item.frice}</td>
              <td style={{ textAlign: 'right' }}>{item.sfrice}</td>
            </tr>
          ))}
          <tr
            className='tableheader'
          >
            <td colSpan={2} style={{ textAlign: 'center' }}>
              Total
            </td>
            <td style={{ textAlign: 'right' }}>{totals.totalCards}</td>
            <td style={{ textAlign: 'right' }}>{totals.drawlRc}</td>
            <td style={{ textAlign: 'right' }}>{totals.wheat.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}>{totals.sugar.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}>{totals.frice.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}>{totals.sfrice.toFixed(2)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Portability_Drawl_Fps;
